import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/inventory-volumes/new/loading';

export const Route = createFileRoute('/_private/settings/inventory-volumes/new')({
  component: Loading,
});
